// PAGE TITLE
export const TITLE_PREFIX = 'RMA';

// ROUTES
export const RMA_ROUTE_PREFIX = 'rma';
export const RMA_INDEX_ROUTE = `/${RMA_ROUTE_PREFIX}`;
export const RMA_DETAILS_PATH = `/${RMA_ROUTE_PREFIX}/:id`;
export const RMA_DETAILS_ROUTE = `/${RMA_ROUTE_PREFIX}`;
